export class CrossTableDTO {
    PK;
    SK;
    id;
    createdAt;
    updatedAt;
    type;
    tenantId;
    categoricalQuestions;
    analysisQuestions;
    uniquePerUser;
    startDate;
    endDate;

    constructor(payload, tenant) {
        this.PK = `${tenant.id}#CROSSTABLEANALYSIS`;
        if (payload.id === undefined) {
            this.SK = `ANALYSIS#`;
        } else {
            this.SK = `ANALYSIS#${payload.id}`;
        }
        this.id = payload.id;
        this.type = "CROSSTABLEANALYSIS";
        this.tenantId = tenant.id;
        this.categoricalQuestions = payload.categoricalQuestions ? payload.categoricalQuestions : [];
        this.analysisQuestions = payload.analysisQuestions ? payload.analysisQuestions : [];
        this.uniquePerUser = payload.uniquePerUser ? payload.uniquePerUser : false;
        this.startDate = payload.startDate ? payload.startDate : null;
        this.endDate = payload.endDate ? payload.endDate : null;
    }
}